<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items="logs"
                    with-items
                    :fields="fields"
                    name="seyir-location"
                    pagination="client">
                    <template #additional-actions>
                        <div class="row">
                            <div class="col-md-3 mb-1 mb-md-0">
                                <v-date-picker v-model="date" placeholder="Tarih Seçiniz"></v-date-picker>
                            </div>
                            <div class="col-md-auto mb-1 mb-md-0">
                                <button class="btn btn-success w-100" v-on:click="getLogs">
                                    Sorgula
                                </button>
                            </div>
                        </div>
                    </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SeyirApi from '@/api/seyir'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
    },
    data(){
        return{
            date:null,
            fields:Additional.ConvertAutoTable([
                "DiffgrId",
                "MsdataRowOrder",
                "data_id",
                "owner",
                "device_id",
                "data_time",
                "is_gps_active",
                "is_vehicle_running",
                "vehicle",
                "address",
                "sat_count",
                "latitude",
                "longitude",
                "altitude",
                "angle",
                "speed",
                "km",
                "total_km",
                "fuel_level",
                "total_fuel",
                "driver_id",
                "driver2_id",
                "driver",
                "driver2",
                "area_id",
                "country",
                "province",
                "district",
                "postal_code"
            ],[],'text-nowrap'),
            logs:[]
        }
    },
    methods:{
        getLogs(){
            if(this.date){
                this.$refs.table.setLoading(true)
                SeyirApi.LocationLogs(this.date).then(res=>{
                    this.$refs.table.setLoading(false)
                    if(res.data.Success){
                        this.logs = res.data.Data || []
                    }else this.$result(res)
                    
                })
            }
        }
    }
}
</script>

<style>

</style>